import React, {FunctionComponent} from 'react';
import {RouteComponentProps} from 'react-router-dom';

const DOMO_DEMO_URL = 'https://public.domo.com/embed/pages/ep0Ar';

export const OrganizationAnalytics: FunctionComponent<RouteComponentProps> = (
    props: RouteComponentProps
) => <iframe className="domo-demo-iframe" src={DOMO_DEMO_URL} />;

export default OrganizationAnalytics;
